export default class Basket {
    constructor (dto) {
        this.id = -1
        this.name = ''
        this.conditionStr = ''
        this.displayConditionStr = ''
        this.roleTypeIDs = []
        this.contentTypeIDs = []
        this.orderAsc = false

        if (dto) {
            this.id = dto.Id
            this.name = dto.Name
            this.conditionStr = dto.ConditionStr
            this.displayConditionStr = dto.DisplayConditionStr
            this.roleTypeIDs = dto.RoleTypeIDs.map(x => x + '')
            this.contentTypeIDs = dto.ContentTypeIDs.map(x => x + '')
            this.orderAsc = dto.OrderAsc
        }
    }

    toDto () {
        return {
            Id: this.id,
            Name: this.name,
            ConditionStr: this.conditionStr,
            RoleTypeIDs: this.roleTypeIDs.map(x => parseInt(x)),
            ContentTypeIDs: this.contentTypeIDs.map(x => parseInt(x)),
            OrderAsc: this.orderAsc,
        }
    }
}
